// extracted by mini-css-extract-plugin
export default {"cardImgTop":"Bonuses_cardImgTop__yV+7+","cardImgTopWrapper":"Bonuses_cardImgTopWrapper__Ma02o"};